export const API_ERROR = "api_failed";
export const CLEAR_DATA = "SR_Clear_data";

export const INPUT_CHANGEVALUE = "input_ChangeValue";
export const SELECT_CHANGEVALUE = "Select_ChangeValue";
export const SR_INPUT_CHANGEVALUE = "sr_input_ChangeValue";
export const SR_SELECT_CHANGEVALUE = "sr_Select_ChangeValue";
export const SI_INPUT_CHANGEVALUE = "SI_input_ChangeValue";
export const ITEM_QTY_CHANGEVALUE = "sr_item_Qty-changeValue";
export const ITEM_UNITES_CHANGEVALUE = "Item_units_changeValue";
export const SI_SELECT_CHANGEVALUE = "SI_Select_ChangeValue";
export const PRODUCTS_REQUEST_LIST = "sr_products_request_list";
export const PRODUCTS_REQUEST_LIST_SUCCESS = "sr_products_request_list_success";
export const PRODUCTS_ROW_REQUEST = "products_Row_request";
export const PRODUCTS_ROW_REQUEST_SUCCESS = "products_Row_request_success";
export const SELECTED_PRODUCTS_LIST = "selected_products_list";
export const REMOVE_SELECTED_PRODUCT = "remove_selected_product";
export const SERVICEREQUEST_ADD = "servicerequest_add";
export const SERVICEREQUEST_ADD_SUCCESS = "servicerequest_add_success";
export const MY_SERVICEREQUEST_LIST = "My_servicerequest_List";

export const SERVICEREQUEST_LIST = "servicerequest_List";
export const DEPT_SERVICEREQUEST_LIST = "Dept_servicerequest_List";
export const ALL_SERVICEREQUEST_LIST = "all_servicerequest_List";
export const SERVICEREQUEST_LIST_COUNT = "servicerequest_List_Count";
export const MY_SERVICEREQUEST_LIST_COUNT = "my_servicerequest_List_Count";
export const DEPT_SERVICEREQUEST_LIST_COUNT =
  "dept_servicerequest_List_Count";
export const ALL_SERVICEREQUEST_LIST_COUNT = "all_servicerequest_List_Count";

export const SERVICEREQUEST_LIST_COUNT_SUCCESS =
  "servicerequest_list_Count_success";
export const SERVICEREQUEST_LIST_SUCCESS = "servicerequest_list_success";

export const GET_USER_DEPARTMENT = "servicerequest_get_User_Department";
export const USER_DEPARTMENT_SUCCESS =
  "servicerequest_get_User_Department_success";
export const SERVICEREQUEST_ROW_DATA = "servicerequest_Row_Data";
export const SERVICEREQUEST_ROW_DATA_SUCCESS = "servicerequest_Row_success";

export const TOGGLE_ITEM_MENU = "servicerequest_toggle_item_Menu";

export const SERVICEREQUEST_DELETE = "servicerequest_delete";
export const ITEM_HOD_APPROVAL = "itemHodApproval";
export const SR_DEPT_HOD_APPROVE_ADD = "sr_dept_hod_approve_add";

export const ALL_SR_HOD_ITEM_LIST_CHECKED = "All_sr_hod_items_list_Checked";
export const SR_HOD_ITEM_LIST_CHECKED = "sr_hod_items_list_Checked";
export const SR_ITEM_HOD_APPROVAL = "SritemHodApproval";
export const SRI_STORE_USER_APPROVAL = "Sr_SRISUserApproval";
export const SRI_STORE_HOD_APPROVAL = "Sr_SRISHodApproval";
export const SR_HOD_APPROVE_ADD = "sr_hod_approve_add";
export const MODEL_OPEN = "sr_addItem_model_open";
export const MODEL_CLOSE = "sr_addItem_model_close";
export const SR_MODEL_LIST_OPEN = "SR_listItem_model_open";
export const MODEL_LIST_CLOSE = "listItem_model_close";
export const MT_ROW_LOADING = "sr_Row_loading";
export const C_PRODUCT_IMAGE = "c_product_image";
export const C_PRODUCT_CHANGEVALUE = "c_product_ChangeValue";
export const C_PRODUCT_SELECT_CHANGEVALUE = "c_product_Select_ChangeValue";
export const CUSTOM_PRODUCT_ADD = "custom_product_add";
export const CUSTOMPRODUCT_ADD_SUCCESS = "customproduct_add_success";
export const CHANGE_TOGGALE_TAB = "change_toggale_tab";
export const SET_PARAMS = "mi_set_params";
export const FILTER_INPUT_CHANGEVALUE = "mi_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "mi_Filter_Select_ChangeValue";
export const LIST_LAYOUT = "mi_list_layout";

export const CHANGE_ITEM_MODEL_OPEN = "sr_dept_change_item_model_open";
export const CHANGE_ITEM_MODEL_CLOSE = "sr_dept_change_item_model_close";

// C_PRODUCT_RIGHT_SIDEBAR
export const C_PRODUCT_RIGHT_SIDEBAR = "C_PRODUCT_RIGHT_SIDEBAR";
export const C_PRODUCT_HIDE_RIGHT_SIDEBAR = "C_PRODUCT_HIDE_RIGHT_SIDEBAR";
export const CHANGE_ACTIVATE_PRODUCT = "CHANGE_ACTIVATE_PRODUCT";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "sr_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "sr_filter_hide_right_sidebar";
export const CLEAR_FILTER = "sr_clear_filter";

export const VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR = "sr_viewLog_show_right_sidebar";
export const VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR = "sr_viewLog_hide_right_sidebar";

export const SR_ITEM_TIME_LINE = "sr_item_time_line";
export const ITEM_TIME_LINE_SUCCESSFUL = "sr_item_time_line_successful";
export const PI_ITEM_TIME_LINE = "sr_PI_item_time_line";
export const PO_ITEM_TIME_LINE = "sr_PO_item_time_line";
export const IGP_ITEM_TIME_LINE = "sr_IGP_item_time_line ";

export const PRODUCT_STORE_QTY = "SR_getProductStoreQty";
export const PRODUCT_STORE_QTY_SUCCESSFUL = "SR_getProductStoreQtySuccessful";

export const PDF_DOWNNLOAD = "SR_PDF_Download";

export const PRODUCT_HISTORY = "SR_product_history";
export const PRODUCT_HISTORY_SUCCESSFUL = "SR_product_history_successful";
export const PRODUCT_HISTORY_MODEL_CLOSE = "SR_product_history_model_close";

export const SR_ITEM_IMAGES_UPLOAD = "SR_item_images_upload";

export const SR_ITEM_UPDATE_IMAGE = "SR_item_update_images";

export const SR_PRODUCT_ITEM_HISTORY_MODEL_OPEN =
  "SR_product_Item_history_modelOpen";
export const PRODUCT_ITEM_HISTORY_MODEL_CLOSE =
  "SR_product_Item_history_modelClose";

export const SERVICE_REQUEST_CLOSE = "service_request_close";

export const SRQ_FOCUS_POST = "srqFocusPost";
